import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import { AssetType } from '/@/modules/asset/enums/AssetType';
import { getters } from '/@/modules/core/app/helpers/store';
import { EstateType } from '/@/modules/estate/enums/EstateType';

export class AssetTypeService extends BaseService {
  /**
   * @returns {string}
   */
  get estateType() {
    return getters.auth.getCurrentEstate()?.type;
  }

  /**
   * @return {array<object>|Error}
   */
  getValues() {
    switch (this.estateType) {
      case EstateType.CLEAR_VAULT.key:
        return this.getClearVaultAssets();
      case EstateType.CLEAR_ESTATE.key:
        return this.getClearEstateAssets();
      case EstateType.CLEAR_WILL.key:
        return this.getClearVaultAssets();
      default:
        throw new Error(`unknown product type selected: ${this.estateType}`);
    }
  }

  getKeyValues() {
    return this.getValues().reduce(
      (obj, item) => Object.assign(obj, { [item.key]: { ...item } }),
      {}
    );
  }

  /**
   * @return {array<object>}
   */
  getClearVaultAssets() {
    return [
      AssetType.ART_JEWELRY,
      AssetType.BANK_ACCOUNT,
      AssetType.BELONGING,
      AssetType.CASH,
      AssetType.CRYPTOCURRENCY,
      AssetType.FIREARM,
      AssetType.INCOME,
      AssetType.LIFE_INSURANCE,
      AssetType.PENSION_PLAN,
      AssetType.PRIVATE_STOCK,
      AssetType.REAL_ESTATE,
      AssetType.VEHICLE,
      AssetType.FUNERAL_PRE_ARRANGEMENT,
      AssetType.LAND,
      AssetType.OTHER
    ];
  }

  /**
   * @return {array<object>}
   */
  getClearEstateAssets() {
    return [
      AssetType.ART_JEWELRY,
      AssetType.BANK_ACCOUNT,
      AssetType.BELONGING,
      AssetType.CASH,
      AssetType.CRYPTOCURRENCY,
      AssetType.FIREARM,
      AssetType.INCOME,
      AssetType.LIFE_INSURANCE,
      AssetType.PENSION_PLAN,
      AssetType.PRIVATE_STOCK,
      AssetType.REAL_ESTATE,
      AssetType.VEHICLE,
      AssetType.LAND
    ];
  }

  /**
   * @return {array<object>}
   */
  getCanBeLiquidated() {
    return [
      AssetType.REAL_ESTATE,
      AssetType.VEHICLE,
      AssetType.PENSION_PLAN,
      AssetType.LIFE_INSURANCE,
      AssetType.ART_JEWELRY,
      AssetType.BELONGING,
      AssetType.BANK_ACCOUNT,
      AssetType.PRIVATE_STOCK,
      AssetType.CRYPTOCURRENCY,
      AssetType.FIREARM,
      AssetType.CASH
    ];
  }

  /**
   * @return {array<object>}
   */
  getCanBeDistributed() {
    return [
      AssetType.REAL_ESTATE,
      AssetType.VEHICLE,
      AssetType.ART_JEWELRY,
      AssetType.CRYPTOCURRENCY,
      AssetType.PRIVATE_STOCK,
      AssetType.FIREARM,
      AssetType.CASH,
      AssetType.BELONGING
    ];
  }

  /**
   * @return {array<object>}
   */
  getCanBeReceived() {
    return [AssetType.INCOME];
  }

  /**
   * @return {array<object>}
   */
  getCanBeDiscarded() {
    return [AssetType.VEHICLE, AssetType.BELONGING];
  }

  /**
   * @return {array<object>}
   */
  getLiquidAssets() {
    return [AssetType.BANK_ACCOUNT, AssetType.CASH];
  }
}

export default new AssetTypeService();
